import { resolveTheme } from '../../designTokens';

const SIZES = {
  sm: { width: '26px', height: '26px', fontSize: '0.72em' },
  md: { width: '32px', height: '32px', fontSize: '0.8em'  },
  lg: { width: '42px', height: '42px', fontSize: '1em'    },
};

function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function Avatar({ theme, name, size = 'md' }) {
  const t = theme || resolveTheme();
  const sz = SIZES[size] || SIZES.md;
  return (
    <div style={{
      ...sz,
      borderRadius: '999px',
      background: t.accent_soft_bg,
      color: t.accent_soft_text,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      flexShrink: 0,
    }}>
      {initials(name)}
    </div>
  );
}
